<template>

  <div class="box-table" :class="investmentDetailView ? 'loading' : ''">
    <div>
      <span ><b>Mostrar por: </b>
        <select name="" @change="optionState($event)" class="select-state">
          <option value=""> Todos los estados </option>
          <option value="3"> Activa </option>
          <option value="4"> Cancelada </option>
          <option value="8"> Fondeada </option>
          <option value="5"> Morosa </option>
          <option value="6"> Pagada </option>
          <option value="7"> Pagada  Morosa</option>
          <option value="2"> Publicada </option>
          <option value="9"> Reestructurada </option>
        </select>
      </span>
      <button type="button" class="button button-small dirty-margin float-right"
        @click="exportExcel">Exportar datos a Excel
      </button>
    </div>
    <div class="horizontal-responsive">
      <table class="table-investment">
        <tr>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-enterprise', 'enterprise')"
              v-if="sortValues.enterprise">
              Empresa</a>
            <a href="#"
              @click.prevent="sortFunction('enterprise', 'enterprise')"
              v-if="!sortValues.enterprise">
              Empresa </a>
            <span v-if="showArrow === 'enterprise'">
              <b v-if="sortValues.enterprise">↑</b>
              <b v-if="!sortValues.enterprise">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-funding_request', 'requestId')"
              v-if="sortValues.requestId">ID solicitud</a>
            <a href="#"
              @click.prevent="sortFunction('funding_request', 'requestId')"
              v-if="!sortValues.requestId">ID solicitud</a>
            <span v-if="showArrow === 'requestId'">
              <b v-if="sortValues.requestId">↑</b>
              <b v-if="!sortValues.requestId">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-funding_state', 'status')"
              v-if="sortValues.status">Estado solicitud</a>
            <a href="#"
              @click.prevent="sortFunction('funding_state', 'status')"
              v-if="!sortValues.status">Estado solicitud</a>
            <span v-if="showArrow === 'status'">
              <b v-if="sortValues.status">↑</b>
              <b v-if="!sortValues.status">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-amount', 'amount')"
              v-if="sortValues.amount">Monto de inversión</a>
            <a href="#"
              @click.prevent="sortFunction('amount', 'amount')"
              v-if="!sortValues.amount">Monto de inversión</a>
            <span v-if="showArrow === 'amount'">
              <b v-if="sortValues.amount">↑</b>
              <b v-if="!sortValues.amount">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-duration', 'duration')"
              v-if="sortValues.duration">Plazo solicitud</a>
            <a href="#"
              @click.prevent="sortFunction('duration', 'duration')"
              v-if="!sortValues.duration">Plazo solicitud</a>
            <span v-if="showArrow === 'duration'">
              <b v-if="sortValues.duration">↑</b>
              <b v-if="!sortValues.duration">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-rate', 'rate')"
              v-if="sortValues.rate">Tasa</a>
            <a href="#"
              @click.prevent="sortFunction('rate', 'rate')"
              v-if="!sortValues.rate">Tasa</a>
            <span v-if="showArrow === 'rate'">
              <b v-if="sortValues.rate">↑</b>
              <b v-if="!sortValues.rate">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-approved_date', 'approved')"
              v-if="sortValues.approved">Aprobación de inversión</a>
            <a href="#"
              @click.prevent="sortFunction('approved_date', 'approved')"
              v-if="!sortValues.approved">Aprobación de inversión</a>
            <span v-if="showArrow === 'approved'">
              <b v-if="sortValues.approved">↑</b>
              <b v-if="!sortValues.approved">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-payment_date', 'promise')"
              v-if="sortValues.promise">Promesa de pago</a>
            <a href="#"
              @click.prevent="sortFunction('payment_date', 'promise')"
              v-if="!sortValues.promise">Promesa de pago</a>
            <span v-if="showArrow === 'promise'">
              <b v-if="sortValues.promise">↑</b>
              <b v-if="!sortValues.promise">↓</b>
            </span>
          </th>
          <th>
            <a href="#"
              @click.prevent="sortFunction('-activation_date', 'activation')"
              v-if="sortValues.activation">Activación de solicitud</a>
            <a href="#"
              @click.prevent="sortFunction('activation_date', 'activation')"
              v-if="!sortValues.activation">Activación de solicitud</a>
            <span v-if="showArrow === 'activation'">
              <b v-if="sortValues.activation">↑</b>
              <b v-if="!sortValues.activation">↓</b>
            </span>
          </th>
          <th>Mensajes</th>
          <th></th>
        </tr>
        <tr v-for="investment in list.results" :key="investment.id">
          <td>{{ investment.enterprise }}</td>
          <td>{{ investment.funding_request_id }}</td>
          <td>{{ investment.funding_state }}</td>
          <td>{{ formatCurrency( Number(investment.amount)) }}</td>
          <td>{{ investment.duration }} días</td>
          <td>{{ formatPercentage(investment.rate) }}</td>
          <td
            v-if="investment.approved_date !== null">
            {{ format(investment.approved_date, 'DD/MM/YYYY') }}
          </td>
          <td class="-centered-info" v-else>-</td>
          <td
            v-if="investment.payment_date !== null">
            {{ format(investment.payment_date, 'DD/MM/YYYY') }}
          </td>
          <td class="-centered-info" v-else>-</td>
          <td
            v-if="investment.activation_date !== null">
            {{ format(investment.activation_date, 'DD/MM/YYYY') }}
          </td>
          <td class="-centered-info" v-else>-</td>
          <td>
            <button
              class="button button-small -message"
              :disabled="investment.funding_request_notification_count === 0"
              @click="getFundingMessage(investment.funding_request_id)">
              {{ investment.funding_request_notification_count }}
            </button>
          </td>
          <td>
            <button
              class="button button-small"
              @click="seeFRDetails(investment.id, investment.funding_request_id)">
              Ver detalle
            </button>
          </td>
        </tr>
      </table>
      <p class="-centered-info">
        <small
          v-if="totalPages !== 0">
          {{ currentPage }} de {{ totalPages }}
        </small>
        <span v-else>No se encontraron registros</span>
      </p>
    </div>
    <div class="table-pagination -centered-info">
      <button
        class="button button-small"
        @click="paginationTable(list.previous, 'previous')"
        :disabled="list.previous === null">Anterior</button>
      <button
        class="button button-small"
        @click="paginationTable(list.next)"
        :disabled="list.next === null">Siguiente</button>
    </div>
    <modal
      name="investment-detail"
      classes="modal-investment v--modal-box v--modal"
      height="auto" width="100%" :maxWidth="800"
      :adaptive="true">
      <DashboardInvestmentDetail
        :frId="selectedFR" :investmentId="selectedInvestmentId" />
    </modal>
    <modal
      name="funding-messages"
      classes="modal-investment v--modal-box v--modal"
      height="auto" width="70%" :maxWidth="800"
      :adaptive="true" :scrollable="true"
      @before-close="fundingMessages = {}">
      <DashboardInvestmentFundingMessage
        :messages="fundingMessages">
      </DashboardInvestmentFundingMessage>
    </modal>
  </div>

</template>

<script>

import DashboardInvestmentFundingMessage
  from './DashboardInvestmentFundingMessage'
import DashboardInvestmentDetail from './DashboardInvestmentDetail'

import { format } from 'date-fns'
import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'
import XLSX from 'xlsx'

export default {
  name: 'ModalInvoicesDetail',
  components: {
    DashboardInvestmentFundingMessage,
    DashboardInvestmentDetail
  },
  mixins: [mixins, httpRequestMixin],
  props: { investmentList: Object },
  data () {
    return {
      selectedFR: null,
      selectedInvestmentId: null,
      format,
      list: {},
      sortValues: {
        enterprise: false,
        requestId: false,
        status: false,
        amount: false,
        duration: false,
        rate: false,
        approved: false,
        promise: false,
        activation: false,
        order: null
      },
      fundingMessages: {},
      requestState: '',
      investmentDetailView: false,
      invoicesDetailsData: [],
      amount: false,
      totalPages: 1,
      currentPage: 1,
      showArrow: null,
      dataExportExcel: [],
      totalRecords: 0
    }
  },
  created: function () {
    this.list = this.investmentList
    this.totalRecords = this.list.count
    if (this.list.count >= 10) {
      this.totalPages = Math.ceil(this.list.count / 10)
    }
  },
  methods: {
    getFundingMessage: async function (id) {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/fr-notifications/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          fr_id: id
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.fundingMessages = response.data.results
          this.$modal.show('funding-messages')
        }
      }
    },
    sortFunction: function (value, field) {
      if (!field) for (let i in this.sortValues) this.sortValues[i] = false

      this.sortValues[field] = !this.sortValues[field]
      this.sortServerValues(value, field)

      this.showArrow = field
    },
    sortServerValues: async function (value) {
      this.sortValues.order = value
      let options = {
        method: 'GET',
        url: this.checkProtocol(process.env.AUTH_BASE + '/investments/'),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          funding_request__state: this.requestState,
          limit: 10,
          offset: 0,
          ordering: value
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.list = response.data
          this.currentPage = 1
          this.totalPages = Math.ceil(this.list.count / 10)
        }
      }
    },
    getExportValues: async function () {
      let options = {
        method: 'GET',
        url: this.checkProtocol(process.env.AUTH_BASE + '/investments/'),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          limit: this.totalRecords
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 200) {
        this.dataExportExcel = response.data.results.map((result) => {
          delete result.id
          delete result.funding_request_notification_count

          return result
        })
      }
    },
    optionState: function (event) {
      this.requestState = event.target.value
      this.sortServerValues(this.sortValues.order)
    },
    seeFRDetails: function (investmentId, frId) {
      this.selectedFR = frId
      this.selectedInvestmentId = investmentId
      this.$modal.show('investment-detail')
    },
    exportExcel: async function () {
      await this.getExportValues()
      let data = XLSX.utils.json_to_sheet(
        this.dataExportExcel,
        {
          header: [
            'enterprise',
            'funding_request_id',
            'funding_state',
            'amount',
            'duration',
            'rate',
            'approved_date',
            'payment_date',
            'activation_date'
          ]
        }
      )

      let wscols = [
        {wpx: 200},
        {wpx: 80},
        {wpx: 80},
        {wpx: 80},
        {wpx: 80},
        {wpx: 80},
        {wpx: 80},
        {wpx: 80},
        {wpx: 150}
      ]

      data['!cols'] = wscols

      data['A1'].v = 'empresa'
      data['B1'].v = 'id_solicitud'
      data['C1'].v = 'estado_solicitud'
      data['D1'].v = 'monto_de_inversión'
      data['E1'].v = 'plazo_solicitud'
      data['F1'].v = 'tasa'
      data['G1'].v = 'Aprobación_de_inversión'
      data['H1'].v = 'promesa_de_pago'
      data['I1'].v = 'activación_de_solicitud'

      const workbook = XLSX.utils.book_new()
      const filename = 'cumplo-inversiones'

      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    }
  }
}

</script>

<style lang="scss">

.loading {
  cursor: wait;
}

.state {
  text-transform: capitalize;
}

.table-pagination {
  margin-top: 2rem;
}

.button.-message {
  position: relative;
  height: 2.4rem;
  line-height: 2.4rem;
  background-color: $yellow;
  border-width: 0;

  &:hover {
    background-color: $yellow;
  }

  &:before {
    $s: 10px;

    content: '';
    position: absolute;
    bottom: -$s;
    left: 4px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: $s $s 0 0;
    border-color: $yellow transparent transparent transparent;
  }
}

.table-investment {
  td,
  th {
    font-size: .9em;
    line-height: 1.2;
  }
  th b {
    color: #999;
  }
}

.select-state{
    width: 160px;
    height: 27px;
    padding: 2px 8px 2px 8px;
    margin-left: 5px;
}

.dirty-margin {
  margin-bottom: -4rem;

  @media (max-width: 42rem) {
    float: none;
    margin: 0 auto 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/dashboardInvestment/DashboardInvestmentTable.vue